<div class="table-responsive">
  <div class="card">
    <div class="card-body">

      <div class="row">
        <div class="col-sm-8 mb-1">
          <h3>Application Configurations</h3>
        </div>
      </div>
      <p-table [lazy]="true" [columns]="cols" (onLazyLoad)="loadConfigData($event)" [value]="configurations"
        dataKey="id" styleClass="p-datatable-config" [rowHover]="true" [rows]="10"
        [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,25,50]" [loading]="loading"
        responsiveLayout="scroll" [paginator]="true" [autoLayout]="true" [totalRecords]="totalRecords"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [filterDelay]="0" paginatorDropdownAppendTo="body">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th style="width:6rem">View/Edit</th>
            <th >
              <div class="flex justify-content-between align-items-center">
                Config Name
              </div>
            </th>
            <th>
              <div class="flex justify-content-between align-items-center">
                Type
              </div>
            </th>
            <th>
              <div class="flex justify-content-between align-items-center">
                Value
              </div>
            </th>
            <th >
              <div class="flex justify-content-between align-items-center">
                Updated On
              </div>
            </th>

          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-configuration let-columns="columns">
          <tr>
            <td>
              <div class="flex justify-content-between align-items-center">
                                <a pTooltip="View configuration" appActionTooltip class="btn btn-info btn-sm" (click)="viewConfiguration(configuration)" role="button"><i class="
                            mdi mdi-eye"></i></a>
                <a pTooltip="Edit configuration" appActionTooltip class="btn btn-warning btn-sm" (click)="editConfiguration(configuration)"
                  role="button"><i class="mdi mdi-pencil"></i></a>
                </div>
              </td>
              @for (col of columns; track col) {
                <td>{{configuration[col.field]}}</td>
              }
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns && columns.length">
                No records found
              </td>
            </tr>
          </ng-template>
        </p-table>

      </div>
    </div>
  </div>

  <p-dialog [(visible)]="configDialog" (onHide)="closeDialog()" [style]="{'width': '80%', 'max-height':'85%'}"
    [resizable]="false" [draggable]="false" [header]="title" [modal]="true" styleClass="p-fluid">
    <ng-template pTemplate="content">
      <app-notification [errorMsg]="errorMsg"></app-notification>

      <div class="card config-view">
        <div class="card-body">
          <form [formGroup]="configForm">
            <div class="row">
              <div class="col-xl-3">
                <div class="mb-1">
                  <label for="organizationId" class="form-label" disabled>Configuration Name</label>
                  <input readonly class="form-control" type="text" formControlName="name" id="name">
                </div>
              </div>
              <div class="col-xl-3">
                <div class="mb-1">
                  <label for="type" class="form-label">Type</label>
                  <input readonly class="form-control" type="text" formControlName="type" id="name">
                </div>
              </div>
              <div class="col-xl-3">
                <div class="mb-1">
                  <label for="value" class="form-label">Value</label>
                  @if (configForm.get('type').value.toLowerCase() === 'number') {
                    <div>
                      <input type="number" class="form-control" id="value" formControlName="value">
                    </div>
                  }
                  @if (configForm.get('type').value.toLowerCase() === 'string') {
                    <div>
                      <input type="text" class="form-control"  id="value" formControlName="value">
                    </div>
                  }
                  @if (configForm.get('type').value.toLowerCase() === 'date') {
                    <div>
                      <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true"
                        yearRange="2010:2030" dateFormat="mm/dd/yy" formControlName="value">
                      </p-calendar>
                    </div>
                  }
                  @if (configForm.get('type').value.toLowerCase() === 'time') {
                    <div>
                      <p-calendar appendTo="body" [showTime]="true" hourFormat="24" [timeOnly]="true"
                        formControlName="value" [defaultDate]="defaultTime">
                      </p-calendar>
                    </div>
                  }
                </div>
              </div>
              @if (!viewOnly) {
                <div class="col-xl-3">
                  <div class="mb-1" style="margin-top: 10%;">
                    <span appActionTooltip [pTooltip]="editLoader ? getSaveDisabledReason() : 'Save configuration changes'" [actionDisabled]="editLoader">
                      <button class="btn btn-primary" (click)="saveConfig()" [disabled]="editLoader">Save@if (editLoader) {
                        <i style="margin-left: 7px;" class="fa fa-solid fa-sync fa-spin"></i>
                      }</button>
                    </span>
                  </div>
                </div>
              }
            </div>
          </form>
        </div>
      </div>
    </ng-template>
  </p-dialog>
